import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../../store/context/simple-context";
import TrackedLink from "../../../Analytics/TrackedLink";
import "./index.scss";

const LearnMore = ({ path }) => {
  if (!path) {
    return null;
  }
  const {
    data: { eventCategory },
    translate: { language, t },
  } = useContext(SimpleContext);

  const updatePathLink = (path) =>
    path === "/amazon-sellers-bundle/?r=pricing_mainsite"
      ? `${language === "ja" ? `${process.env.MAIN_HOST}/jp` : ""}${path}`
      : path;

  return (
    <TrackedLink
      class="GP-C__LearnMore"
      target
      category={eventCategory}
      action="Learn more"
      path={updatePathLink(path)}
    >
      {t("Learn more")}
    </TrackedLink>
  );
};
LearnMore.propTypes = {
  path: PropTypes.string,
};

export default LearnMore;
